import {Component, OnInit} from '@angular/core';
import {PublicationModel} from '../../models/publication.model';
import {Router} from '@angular/router';
import {ConfirmationService} from 'primeng/api';
import {I18nService} from '../../../shared/i18n';
import {Observable} from 'rxjs/Observable';
import {ReportService} from '../../services/report.service';
import {NotificationService} from '../../../shared/utils/notification.service';
import * as FileSaver from 'file-saver';
import {AppCommunicationService} from '../../services/app-communication.service';
import {IsbnChangedReportModel} from '../../models/isbnChangedReport.model';
import {removeDiacriticsFromString} from '../../misc/remove-diacritics-from-string';

@Component({
    selector: 'app-generate-report-view',
    templateUrl: './generate-report-view.component.html',
    styleUrls: ['./generate-report-view.component.scss']
})

export class GenerateReportViewComponent implements OnInit {
    generatingReport = false
    pTable = {
        colNumber: 7,
        expandedRows: {}
    };
    filterButtons = [
        {
            text: 'Isbn report',
            count: 0,
            active: true,
            color: 'bg-color-blueDark'
        },
        {
            text: 'Prints report',
            count: 0,
            active: false,
            color: 'bg-color-teal'
        },
        {
            text: 'Isbn changed report',
            count: 0,
            active: false,
            color: 'bg-color-blueLight'
        }
    ];

    filter = {
        text: '',
    };

    showReport = 0;

    allIsbnPublications: PublicationModel[] = [];
    allPrintsPublications: PublicationModel[] = [];
    filteredIsbnPublication: PublicationModel[] = [];
    filteredPrintsPublication: PublicationModel[] = [];
    selectedPrintsPublication: PublicationModel[] = [];
    allIsbnChangedReports: IsbnChangedReportModel[] = [];
    filtredIsbnChangedReports: IsbnChangedReportModel[] = [];
    selectedIsbnChangedReport: IsbnChangedReportModel = null;

    isIsbnEmpty = true;
    isPrintsEmpty = true;
    isIsbnChangedReportEmpty = true;

    constructor(private router: Router,
                private confirmationService: ConfirmationService,
                private i18nService: I18nService,
                private reportService: ReportService,
                private notificationService: NotificationService,
                private _appCommunicationService: AppCommunicationService) {
    }

    ngOnInit() {
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Loading data'));
        });
        const getIsbnPublicaiton = this.reportService.getPublicationForIsbnReport();
        const getPrintsPublication = this.reportService.getPublicationForPrintsReport();
        const getIsbnChangedReportNewData = this.reportService.getIsbnChangedReportNewData();

        Observable.forkJoin([getIsbnPublicaiton, getPrintsPublication, getIsbnChangedReportNewData]).subscribe(
            (data: any[]) => {
                this.allIsbnPublications = data[0].items;
                this.isIsbnEmpty = data[0].totalItems === 0;
                this.allPrintsPublications = data[1].items;

                this.allIsbnChangedReports = data[2];

                this.filterData();
                this._appCommunicationService.loadingOff();
                this.calcButtonsCount();
            }, (err) => {
                console.error(err);
                this._appCommunicationService.loadingOff();
            }
        )
    }

    private calcButtonsCount() {
        this.filterButtons[0].count = this.allIsbnPublications.length;
        this.filterButtons[1].count = this.allPrintsPublications.length;
        this.filterButtons[2].count = this.allIsbnChangedReports.length;

    }

    filterData() {
        this.filteredIsbnPublication = this.allIsbnPublications;
        this.filteredPrintsPublication = this.allPrintsPublications;
        this.filtredIsbnChangedReports = this.allIsbnChangedReports
        this.filterByText();
    }


    filterByText() {
        if (this.filter.text !== '') {
            const val = removeDiacriticsFromString(this.filter.text);

            this.filteredIsbnPublication = this.filteredIsbnPublication.filter(publication => {
                if (publication) {
                    if (publication.title && removeDiacriticsFromString(publication.title).includes(val)) {
                        return publication;
                    } else if (publication.isbn && removeDiacriticsFromString(publication.isbn).includes(val)) {
                        return publication;
                    } else if (publication.authors && publication.authors.length > 0) {
                        return publication.authors.find(a => a.surname && removeDiacriticsFromString(a.surname).includes(val));
                    }
                }
            })

            this.filteredPrintsPublication = this.filteredPrintsPublication.filter(publication => {
                if (publication) {
                    if (publication.title && removeDiacriticsFromString(publication.title).includes(val)) {
                        return publication;
                    } else if (publication.isbn && removeDiacriticsFromString(publication.isbn).includes(val)) {
                        return publication;
                    } else if (publication.authors && publication.authors.length > 0) {
                        return publication.authors.find(a => a.surname && removeDiacriticsFromString(a.surname).includes(val));
                    }
                }
            })
        }
    }

    onFilterButtonClick(index: number) {
        this.showReport = index;

        this.filterButtons.forEach(btn => btn.active = false)
        this.filterButtons[index].active = true;
        this.filterData();
    }

    onPublicationSelected($event) {
        this.selectedPrintsPublication = $event;
        this.isPrintsEmpty = this.selectedPrintsPublication.length === 0;
    }

    onIsbnChangedReportSelected($event) {
        this.selectedIsbnChangedReport = $event;
        this.isIsbnChangedReportEmpty = this.selectedIsbnChangedReport === null;

    }

    onGenerateIsbnReportClick() {

        this.notificationService.smartMessageBox({
            title: this.i18nService.getTranslation('confirmation'),
            content: this.i18nService.getTranslation('confirmGenerateReport'),
            buttons: '[' + this.i18nService.getTranslation('No') + '][' +
                this.i18nService.getTranslation('Yes') + ']'
        }, (ButtonPressed) => {
            if (ButtonPressed === this.i18nService.getTranslation('Yes')) {
                this.generatingReport = true;
                setTimeout(() => {
                    this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Generating a report'));
                });
                this.reportService.generateIsbnReport().subscribe((data: Blob) => {
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('saved'),
                        color: '#659265',
                        content: this.i18nService.getTranslation('reportHasBeenGenerated'),
                        timeout: 8000
                    });
                    this._appCommunicationService.loadingOff();
                    FileSaver.saveAs(data, 'ISBN_Report.pdf');
                    this.allIsbnPublications = [];
                    this.filteredIsbnPublication = [];
                    this.generatingReport = false;
                    this.calcButtonsCount();
                }, (err) => {
                    console.error(err);
                    this._appCommunicationService.loadingOff();
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('error'),
                        color: '#923837',
                        iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                        content: this.i18nService.getTranslation('somethingIsWrongError'),
                        timeout: 10000
                    });
                    this.generatingReport = false;
                });
            }
        });
    }

    onGenerateIsbnChangedReportClick() {

        this.notificationService.smartMessageBox({
            title: this.i18nService.getTranslation('confirmGenerateReport'),
            content: this.i18nService.getTranslation('confirmDeleteApply'),
            buttons: '[' + this.i18nService.getTranslation('No') + '][' +
                this.i18nService.getTranslation('Yes') + ']'
        }, (ButtonPressed) => {
            if (ButtonPressed === this.i18nService.getTranslation('Yes')) {
                setTimeout(() => {
                    this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Generating a report'));
                });
                this.generatingReport = true;
                this.reportService.completeIsbnChagedReport(this.selectedIsbnChangedReport.id).subscribe(() => {
                    // open mailto
                    this._appCommunicationService.loadingOff();
                    const email = 'email_kam_se_report_posila@domena.sk';
                    const subject = 'TUKE - Storno ISBN';
                    // const body= this.selectedIsbnChangedReport.comment.split('\n').join('%0D%0A');
                    //  This text created by Žaneta Hronská, in my opinion its wrong...
                    const body = 'Dobrý deň, zasielam Vám informáciu o strornovaných ISBN:' + '%0D%0A' +
                        'ISBN ' + this.selectedIsbnChangedReport.oldPublication + '%0D%0A' +
                        'Názov publikácie : ' + this.selectedIsbnChangedReport.oldPublication.title + '%0D%0A' +
                        'S pozdravom' + '%0D%0A' + 'Hronská';
                    const mailText = 'mailto:' + email + '?subject=' + subject + '&body=' + body;
                    window.location.href = mailText;
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('saved'),
                        color: '#659265',
                        content: this.i18nService.getTranslation('reportHasBeenGenerated'),
                        timeout: 8000
                    });

                    this.allIsbnChangedReports = this.allIsbnChangedReports
                        .filter(ir => this.selectedIsbnChangedReport.id !== ir.id);
                    this.filterData();
                    this.calcButtonsCount();
                    this.generatingReport = false;
                }, (err) => {
                    this._appCommunicationService.loadingOff();
                    console.error(err);
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('error'),
                        color: '#923837',
                        iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                        content: this.i18nService.getTranslation('somethingIsWrongError'),
                        timeout: 10000
                    });
                    this.generatingReport = false;
                })
            }
        });
    }

    onGeneratePrintsReportClick() {
        this.notificationService.smartMessageBox({
            title: this.i18nService.getTranslation('confirmGenerateReport'),
            content: this.i18nService.getTranslation('confirmDeleteApply'),
            buttons: '[' + this.i18nService.getTranslation('No') + '][' +
                this.i18nService.getTranslation('Yes') + ']'
        }, (ButtonPressed) => {
            if (ButtonPressed === this.i18nService.getTranslation('Yes')) {
                setTimeout(() => {
                    this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Generating a report'));
                });
                this.generatingReport = true;
                const publicationIds = this.selectedPrintsPublication.map(p => p.id);
                this.reportService.generatePrintsReport(publicationIds).subscribe((data: Blob) => {
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('saved'),
                        color: '#659265',
                        content: this.i18nService.getTranslation('reportHasBeenGenerated'),
                        timeout: 8000
                    });
                    this._appCommunicationService.loadingOff();
                    FileSaver.saveAs(data, 'Prints_Reports.pdf');
                    this.allPrintsPublications = this.allPrintsPublications
                        .filter(p => !this.selectedPrintsPublication.some(sp => sp.id === p.id));
                    this.filterData();
                    this.calcButtonsCount();
                    this.generatingReport = false;
                }, (err) => {
                    this._appCommunicationService.loadingOff();
                    console.error(err);
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('error'),
                        color: '#923837',
                        iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                        content: this.i18nService.getTranslation('somethingIsWrongError'),
                        timeout: 10000
                    });
                    this.generatingReport = false;
                })
            }
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/views/generate-report-view/generate-report-view.component.ts